import { ProjectStatus } from '../types';
import { getProjectStatusBadgeColors } from '../constants/colorScheme';

const PROJECT_STATUS_ALIASES: Record<string, ProjectStatus> = {
  draft: 'Draft',
  'under review': 'Under Review',
  underreview: 'Under Review',
  approved: 'Approved',
  rejected: 'Rejected',
  'in progress': 'In Progress',
  inprogress: 'In Progress',
  completed: 'Completed',
  complete: 'Completed',
  done: 'Completed',
};

const normalizeStatusKey = (status: string): string => {
  return status
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ');
};

export function normalizeProjectStatus(
  status?: string | null
): ProjectStatus | undefined {
  if (!status) {
    return undefined;
  }

  const key = normalizeStatusKey(status);
  return PROJECT_STATUS_ALIASES[key];
}

export function isProjectInProgress(status?: string | null): boolean {
  return normalizeProjectStatus(status) === 'In Progress';
}

export function matchesProjectStatus(
  status: string | null | undefined,
  filterStatus: ProjectStatus | 'All'
): boolean {
  if (filterStatus === 'All') {
    return true;
  }

  return normalizeProjectStatus(status) === filterStatus;
}

export function getProjectStatusClassName(status?: string | null): string {
  return `border ${getProjectStatusBadgeColors(status || 'Draft')}`;
}
